module.exports = __webpack_public_path__ + "static/media/LogoManyLoginE.26e329c4.svg";